import { useEffect } from 'react';
import { clearQueueScrollLocks, disablePageScroll, enablePageScroll } from 'scroll-lock';
import { canUseDOM } from "../utils/canUseDOM";
var managersCount = 0;

var needDisable = function needDisable(onlyMobile) {
  if (!canUseDOM) return false;
  var isMobile = window.innerWidth <= 767;
  if (onlyMobile && !isMobile) return false;
  return true;
};

function useDisableScroll(_ref) {
  var isOpen = _ref.isOpen,
      onlyMobile = _ref.onlyMobile,
      target = _ref.target;
  useEffect(function () {
    if (target) {
      if (needDisable(onlyMobile) && isOpen) {
        managersCount += 1;
        disablePageScroll(target);
      }

      return function () {
        if (managersCount > 0) {
          managersCount -= 1;
        }

        if (managersCount === 0) {
          clearQueueScrollLocks();
          enablePageScroll(target);
        }
      };
    }

    return function () {
      return null;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, onlyMobile]);
}

export default useDisableScroll;